export default __webpack_public_path__ + "static/post-quantum-cryptography-dati-qubit-a01d3f4fcacddfb94f4fa9e4ea904c16.png";